module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pshou18-428a073529f8da0e6f02b7e7366a0d03.jpg";